import { YearPickerInput, YearPickerInputProps } from '@mantine/dates';
import { POPOVER_Z_INDEX } from '../../lib/zIndex';
import { usePortalTarget } from '../../provider/UiContext';
import { describedByContainer } from '../../theme/describedByContainer';
import { useFieldA11y } from '../../hooks/useFieldA11y';

export type IYearFieldProps = Omit<YearPickerInputProps, 'error'> & {
    invalid?: boolean;
    testid?: string;
};

const YearField = ({
    invalid,
    testid,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    inputContainer,
    ...props
}: IYearFieldProps) => {
    const portalTarget = usePortalTarget();
    // кнопка поля года названа подписью группы (FormGroup), сообщение под полем — её описание
    const fieldA11y = useFieldA11y(
        { 'aria-label': props['aria-label'], 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy },
        !!props.label,
    );
    return (
        <YearPickerInput
            valueFormat="YYYY"
            placeholder={props.placeholder ?? 'Выберите год'}
            clearable
            w="100%"
            {...props}
            aria-labelledby={fieldA11y['aria-labelledby']}
            inputContainer={describedByContainer(fieldA11y['aria-describedby'], inputContainer)}
            popoverProps={{
                shadow: 'md',
                position: 'bottom-start',
                zIndex: POPOVER_Z_INDEX,
                portalProps: portalTarget ? { target: portalTarget } : undefined,
                ...props.popoverProps,
            }}
            error={invalid || undefined}
            data-testid={testid ? `year-field-${testid}` : undefined}
        />
    );
};

export default YearField;
